/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function LinkIcon({ className, size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      className={className}
      viewBox="0 1 15 15"
      fill="none"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M10.011 4.5a3 3 0 11-2.362 4.85l.787-.618a2 2 0 10-.034-2.42l-.804-.594A2.996 2.996 0 0110.011 4.5zm-5.413 0c.934 0 1.797.43 2.362 1.15l-.787.618a2 2 0 10.035 2.42l.803.594A3 3 0 114.598 4.5zM9.5 7a.5.5 0 010 1h-4a.5.5 0 010-1h4z"
      ></path>
    </svg>
  );
}
